import { useEffect, useState } from 'react';
import { theme } from './theme';
import { api, type SessionInfo } from './api';
import { Login } from './components/Login';
import { Portal } from './components/Portal';

type Status =
  | { kind: 'loading' }
  | { kind: 'anonymous' }
  | { kind: 'session'; session: SessionInfo };

export function App() {
  const [status, setStatus] = useState<Status>({ kind: 'loading' });

  useEffect(() => {
    api.me()
      .then((session) => setStatus({ kind: 'session', session }))
      .catch(() => setStatus({ kind: 'anonymous' }));
  }, []);

  if (status.kind === 'loading') {
    return (
      <div style={{
        height: '100vh', display: 'grid', placeItems: 'center',
        background: theme.bg, color: theme.veryDim, fontSize: 12,
      }}>
        loading…
      </div>
    );
  }

  if (status.kind === 'anonymous') {
    const params = new URLSearchParams(window.location.search);
    return <Login next={params.get('next')} />;
  }

  const onLogout = async () => {
    await api.logout().catch(() => {});
    setStatus({ kind: 'anonymous' });
  };

  return <Portal session={status.session} onLogout={onLogout} />;
}
